module.exports = __webpack_public_path__ + "static/media/lock-primary.d27216a7.svg";